import { Organization } from '../../../core/models/organization.model';

export enum GrdfAccessRightStatus {
    //FROM GRDF
    ACTIVE = 'Active',
    PENDING_VALIDATION = 'A valider',
    REFUSED = 'Refusée',
    REVOKED = 'Révoquée',
    CHECK_AGAIN = 'A revérifier',
    OBSOLETE = 'Obsolète',
    //ADDED by ED
    DISABLED = 'Désactivée',
    UNKNOW = 'Non reconnu par GRDF',
}

export enum GrdfAccessRightProofType {
    FILE = 'FILE',
    MAIL = 'MAIL',
    OTHER = 'OTHER',
    EXTERNAL = 'EXTERNAL',
}
export interface GrdfAccessRightModel {
    id: string;
    pdlNumber: string;
    organization: Organization;
    clientRepresentativeName: string;
    clientRepresentativeEmail: string;
    clientRepresentativePhoneNumber: string;
    clientSirenSiret?: string;
    clientName?: string;
    pdlPostalCode: string;
    //Date de début de réccupération des données  (min : consentStart -2 ans )
    consumptionAccessStart: Date;
    //Date de demande du consentement
    consentStart: Date;
    validationDate: Date;
    consentEnd: Date;
    disabledAt?: Date;
    comments?: string;
    //remoteAccessRight?: GrdfRemoteAccessRightModel;
    isCompany: boolean;
    status: GrdfAccessRightStatus;
    errorMessage: string;
    errorAt: Date;
    proofType: GrdfAccessRightProofType;
    localRevokedAt: Date;
    phone: string;
}

export interface GrdfRemoteAccessRightModel {
    id: string;
    id_droit_acces: string;
    id_pce: string;
    role_tiers: string;
    raison_sociale_du_tiers: string;
    nom_titulaire: string;
    raison_sociale_du_titulaire: string;
    courriel_titulaire: string;
    numero_telephone_mobile_titulaire: string;
    code_postal: string;
    date_debut_droit_acces: Date;
    date_fin_droit_acces: Date;
    perim_donnees_conso_debut: Date;
    perim_donnees_conso_fin: Date;
    perim_donnees_inj_debut: Date;
    perim_donnees_inj_fin: Date;
    perim_donnees_contractuelles: boolean;
    perim_donnees_techniques: boolean;
    perim_donnees_informatives: boolean;
    perim_donnees_publiees: boolean;
    perim_flux_de_donnees: boolean;
    perim_historique_de_donnees: boolean;
    date_creation: Date;
    etat_droit_acces: string;
    date_revocation: Date;
    source_revocation: string;
    date_passage_a_obsolete: Date;
    source_passage_a_obsolete: string;
    date_debut_autorisation: Date;
    date_fin_autorisation: Date;
    date_passage_a_refuse: Date;
    source_passage_a_refuse: string;
    parcours: string;
    statut_controle_preuve: string;
    date_limite_transmission_preuve: Date;
}

export const GrdfTechnicalDataDefinition = {
    frequence: `Fréquence de relève associée au PCE ("6M", "1M", "JJ", "MM")`,
    client_sensible_mig: `Client non domestique assurant une mission d'intérêt général (OUI/NON)`,
    code_calibre: `Composé de la lettre G suivi d'un nombre qui représente le débit maximal du compteur de calibre immédiatement inférieur`,
    code_debit: `Débit du compteur en m3/h`,
    code_debit_normalise: `Débit normalisé du compteur (Nm³/h) =(1 +Pression de livraison (bar)) * Débit du compteur (m³/h)`,
    pression_livraison: `Pression relative du Gaz au Point de Livraison`,
    matricule_compteur: `Numéro de matricule du compteur`,
    identifiant_pitd: `Identifiant du Point d'Interface Transport Distribution auquel le PCE est rattaché`,
    libelle_pitd: `Nom du Point d'Interface Transport Distribution auquel le PCE est rattaché`,
};

export interface GrdfTechnicalDataModel {
    id: string;
    numero_rue: string;
    nom_rue: string;
    complement_adresse: string;
    code_postal: string;
    commune: string;
    frequence: string;
    client_sensible_mig: string;
    code_calibre: string;
    code_debit: string;
    code_debit_normalise: string;
    pression_livraison: string;
    matricule_compteur: string;
    identifiant_pitd: string;
    libelle_pitd: string;
    regime_propriete_compteur: string;
    regime_propriete_convertisseur: string;
    regime_propriete_poste: string;
    regime_propriete_enregistreur: string;
}

export const GrdfContractualDataDefinition = {
    date_mes: `Date de la Mise En Service (MES) du PCE correspondante au titulaire actif`,
    tarif_acheminement: `Ce Tarif d'acheminement gaz du titulaire est choisi par le fournisseur en fonction d'une estimation du volume de gaz consommé.\n
Il représente le tarif d'utilisation du réseau public de distribution du gaz naturel.  \n

Les tarifs d'acheminement comprennent plusieurs options tarifaires pour les particuliers et professionnels selon leur volume de consommation :\n
T1 : Consommation inférieure à 6000 kWh / an.\n
T2 : Consommation entre 6000 kWh / an et 300 MWh / an.\n
T3 : Consommation entre 300 MWh / an et 5 GWh / an (essentiellement des entreprises tertiaires ou industrielles de taille moyenne).\n
T4 : Consommation supérieure à 5 GWh / an (grands sites industriels directement rattachés au réseau de distribution de gaz naturel).\n
TP : Tarif de Proximité, il s'agit d'une option tarifaire concernant des clients finaux ayant la possibilité règlementaire de se raccorder au réseau de transport.\n
TB : Tarif Biométhane, il s'agit d'une option tarifaire concernant les producteurs de biométhane`,
    date_publication: `Jour du mois de publication des données publiées aux fournisseurs pour les PCE 1M`,
    consommation_journaliere_plafond: ``,
    car_title: `Consommation Annuelle de Référence (CAR) `,
    car_description: `Quantité de gaz estimée consommée sur une année, dans des conditions climatiques moyennes.
La CAR d'une année N s'appliquent du 1er avril de l'année N au 31 mars de l'année N+1. Elle est mise à jour de manière systématique par le Gestionnaire de Réseau de Distribution (GRD).\n
Unité : entier en kWh`,
    cja_title: `Capacité Journalière d'Acheminement (CJA)`,
    cja_description: `Quantité maximale d'énergie que le distributeur s'engage à acheminer chaque jour en un point de livraison. \n
Elle se compose d'une souscription annuelle à laquelle peut s'ajouter une souscription mensuelle supplémentaire et/ou une souscription journalière supplémentaire. Ce type de donnée est applicable seulement aux compteurs JJ et pour les clients de tarif T4 ou TP (Tarif de Proximité). \n
Unité : entier en kWh/jour`,
    cja_journaliere_mensuelle: `Souscription Journalière et Mensuelle supplémentaire `,
    date_debut_profil_type_actuel: `Date de début de validité du Profil Type actuel`,
    date_fin_profil_type_actuel: `Date de fin de validité du Profil Type actuel`,
    profil_type_actuel: `Le Profil Type (est attribué par le Distributeur) caractérise la répartition de la CAR d'un PCE tout au long de l'année. Il est notamment utilisé entre deux relevés pour estimer les quantités journalières d'un PCE. Ce dernier est déterminé automatiquement par le système d'informations de GRDF à partir de la CAR saisie par le fournisseur (puis chaque année à partir de la CAR recalculée par GRDF). \n
Dix profils types permettent de définir les usages de consommations du gaz naturel :\n
P000 : Client PCE forfait cuisine \n
P011 : Client Gazpar (compteur 1M) ou à relevé semestriel avec une CAR inférieure à 6000 kWh/an (compteur 6M)\n
P012 : Client Gazpar (compteur 1M) ou à relevé semestriel avec une CAR supérieure ou égale à 6000 kWh/an (compteur 6M)\n
P013 : Client à relevé mensuel (compteur MM) ou journalier (compteur JJ) avec une part hiver corrigée moyenne inférieure ou égale à 39% \n
P014 : Client à relevé mensuel (compteur MM) ou journalier (compteur JJ) avec une part hiver corrigée moyenne entre 39% et 50% \n
P015 : Client à relevé mensuel (compteur MM) ou journalier (compteur JJ) avec une part hiver corrigée moyenne entre 50% et 58% \n
P016 : Client à relevé mensuel (compteur MM) ou journalier (compteur JJ) avec une part hiver corrigée moyenne entre 58% et 69% \n
P017 : Client à relevé mensuel (compteur MM) ou journalier (compteur JJ) avec une part hiver corrigée moyenne entre 69% et 75% \n
P018 : Client à relevé mensuel (compteur MM) ou journalier (compteur JJ) avec une part hiver corrigée moyenne entre 75% et 81% \n
P019 : Client à relevé mensuel (compteur MM) ou journalier (compteur JJ) avec une part hiver corrigée moyenne strictement supérieure à 81%\n
\n
Le Profil Type d'une année N s'appliquent du 1er avril de l'année N au 31 mars de l'année N+1. Il est mis à jour de manière systématique par le Gestionnaire de Réseau de Distribution (GRD), une fois par an à date fixe, sauf en cas d'évènement spécifique :\n
- Premières Mise En Service (MES)\n
- Changement de fournisseur avec changement de tarif ou de fréquence de relevé\n
- Changement de données tarifaires\n
- Corrections d'une erreur manifeste (CAR et/ou profil aberrant)`,
    modulation_n_1: ` Modulation de Stockage Année N-1 `,
    modulation_n_2: ` Modulation de Stockage Année N-2 `,
    modulation_n_3: ` Modulation de Stockage Année N-3`,
    modulation_assiette: ` Assiette de compensation de stockage. Moyenne des 2 modulation plus petite.`,
};

export interface GrdfContractualDataModel {
    id: string;
    date_mes: Date;
    tarif_acheminement: string;
    date_publication: Date;
    consommation_journaliere_plafond: string;
    car_actuelle: string;
    car_future: string;
    cja: string;
    cja_journaliere: string;
    cja_mensuelle: string;
    date_debut_profil_type_actuel: Date;
    date_fin_profil_type_actuel: Date;
    profil_type_actuel: string;
    profil_type_futur: string;
    modulation_n_1: string;
    modulation_n_2: string;
    modulation_n_3: string;
    modulation_assiette: string;
}

export enum GrdfConsumptionStep {
    INFORMATIVE = 'Informative',
    PUBLISHED = 'Published',
    DAILY = '1D',
    MONTHLY = '1M',
    YEARLY = '1Y',
}

export const GrdfConsumptionStepLabel: Record<GrdfConsumptionStep, string> = {
    [GrdfConsumptionStep.INFORMATIVE]: 'Brut (informative)',
    [GrdfConsumptionStep.PUBLISHED]: 'Brut (Publiée)',
    [GrdfConsumptionStep.DAILY]: 'Quotidien',
    [GrdfConsumptionStep.MONTHLY]: 'Mensuel',
    [GrdfConsumptionStep.YEARLY]: 'Annuel',
};

export interface GrdfConsumptionModel {
    id: string;

    createdAt: Date;
    dateEnd: Date;
    dateStart: Date;

    consumptionkWh: number;
    typeConsumption: string;

    calcCoeffPta?: number;
    calcConversionCoeff?: number;
    calcValuePcs?: number;
    consumptionQualificationType?: string;
    consumptionStatus?: string;
    convertedVolume?: number;
    flagZeroReturn?: boolean;
    gasDay?: string;
    gasFlowDirection?: string;
    rawVolume?: number;
}
